import React from "react";
import { Outlet } from "react-router-dom";
import { useGlobalNavigate } from "./use-global-navigate";

export const RootNode = () => {
  useGlobalNavigate();

  return (
    <>
      <Outlet />
    </>
  );
};
